var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1875 27.3662C38.2295 27.3662 39.2288 26.9523 39.9655 26.2155M37.1875 27.3662C36.1455 27.3662 35.1462 26.9523 34.4095 26.2155M37.1875 27.3662V30.3125M39.9655 26.2155C40.7023 25.4788 41.1162 24.4795 41.1162 23.4375M39.9655 26.2155L42.0487 28.2987M41.1162 23.4375C41.1162 22.3955 40.7023 21.3962 39.9655 20.6595M41.1162 23.4375H44.0625M39.9655 20.6595C39.2288 19.9227 38.2295 19.5087 37.1875 19.5087M39.9655 20.6595L42.0487 18.5762M37.1875 19.5087C36.1455 19.5087 35.1462 19.9227 34.4095 20.6595M37.1875 19.5087V16.5625M34.4095 20.6595C33.6727 21.3962 33.2588 22.3955 33.2588 23.4375M34.4095 20.6595L32.3263 18.5762M33.2588 23.4375C33.2588 24.4795 33.6727 25.4788 34.4095 26.2155M33.2588 23.4375H30.3125M34.4095 26.2155L32.3263 28.2987M36.5325 16.5625H37.8425M41.5862 18.1137L42.5113 19.0387M44.0625 22.7825V24.0925M42.5113 27.8362L41.5862 28.7612M37.8425 30.3125H36.5325M32.7887 28.7612L31.8638 27.8362M30.3125 24.0925V22.7825M31.8638 19.0387L32.7887 18.1137M24.375 33.75L26.4663 32.1812C26.6797 32.0214 26.9235 31.9067 27.1828 31.8442C27.442 31.7817 27.7113 31.7727 27.9741 31.8177C28.237 31.8627 28.4879 31.9609 28.7116 32.1061C28.9352 32.2514 29.1269 32.4407 29.275 32.6625C29.4895 32.9846 29.6039 33.363 29.6039 33.75C29.6039 34.137 29.4895 34.5154 29.275 34.8375L27.2187 37.9212C26.5869 38.8684 25.6824 39.6016 24.625 40.0237L21.5625 41.25M25.3125 27.1875L20.8188 29.1137C19.4911 29.6824 18.433 30.74 17.8638 32.0675L16.3925 35.5C16.0921 36.2007 15.9373 36.9551 15.9375 37.7175V44.0625",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0625 32.8125V41.25C44.0625 41.9959 43.7662 42.7113 43.2387 43.2387C42.7113 43.7662 41.9959 44.0625 41.25 44.0625H28.125C27.3791 44.0625 26.6637 43.7662 26.1363 43.2387C25.6088 42.7113 25.3125 41.9959 25.3125 41.25V39.6937M25.3125 33.0463V18.75C25.3125 18.0041 25.6088 17.2887 26.1363 16.7613C26.6637 16.2338 27.3791 15.9375 28.125 15.9375H30.3125",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppDevelopment);
export default __webpack_public_path__ + "static/media/mobileAppDevelopment.0c17fed557914b9b1a5e2386a236d812.svg";
export { ForwardRef as ReactComponent };